import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router';

import axios from 'axios';
import { Global } from '../../../Global';


import Loading from '../../../elementos/Loading';
import Input from '../../../elementos/Input';
import Error from '../../../elementos/Error';
import Select from '../../../elementos/Select';

import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';


import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';


export default function ClienteEditMediosDePagoPorAgendaCrear({ dominio, agendas, refreshFunction }) {

    const [open, setOpen] = useState(false);

    const [estadoVista, setEstadoVista] = useState('cargado');

    const [puesto, setPuesto] = useState('');
    const [access_token, setAccessToken] = useState('');
    const [importe_debe, setImporteDebe] = useState('');
    const [importe_valor, setImporteValor] = useState('');

    const urlParams = useParams();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = (e) => {

        e.stopPropagation();
        e.preventDefault();

        if (estadoVista === 'cargado') {

            setEstadoVista('loading');

            const body = {
                puesto: puesto * 1,
                access_token,
                importe_valor: importe_valor * 1,
                importe_debe: importe_debe * 1,
            }

            axios.post(
                `${Global.url_api}cliente/medios-de-pago-por-agenda/${dominio}`,
                body,
                { headers: { Authorization: localStorage.getItem("token") } })
                .then(res => {
                    refreshFunction();
                    setEstadoVista('cargado');
                    handleClose();
                    setPuesto('');
                    setAccessToken('');
                    setImporteDebe('');
                    setImporteValor('');
                })
                .catch((error) => {
                    console.log(error?.response?.data);
                    alert(error?.response?.data?.message);
                    setEstadoVista('cargado');
                });
        }
    }


    if (estadoVista === 'loading') return (<Loading />)

    if (estadoVista === 'error') return (<Error />)

    if (estadoVista === 'cargado')
        return (
            <>
                <Button variant="outlined" onClick={handleClickOpen} size='small'>
                    Nuevo
                </Button>
                <Dialog
                    open={open}
                    onClose={handleClose}
                >
                    <form onSubmit={handleSubmit}>
                        <DialogTitle>Crear Registro</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12} >
                                    Crea una nueva condición de pago para el cliente. Si hay varias opciones para la misma agenda, le ofrecerá todas las opciones al cliente.
                                </Grid>
                                <Grid item xs={12} >
                                    <Input
                                        label="Access Token"
                                        value={access_token}
                                        onChange={setAccessToken}
                                        type="text"
                                        helperText="Access Token de Mercadopago"
                                    />
                                </Grid>
                                <Grid item xs={12} >
                                    <Select
                                        label="Agenda"
                                        value={puesto}
                                        options={agendas.map(item => {
                                            return {
                                                label: item.nombre,
                                                value: item.codigo
                                            }
                                        })}
                                        onChange={setPuesto}
                                        type="text"
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} >
                                    <Select
                                        label="Tipo de Pago"
                                        value={importe_debe}
                                        options={[
                                            {
                                                value: '1',
                                                label: 'Valor Fijo'
                                            },
                                            {
                                                value: '2',
                                                label: 'Porcentaje'
                                            },
                                            {
                                                value: '3',
                                                label: 'Pagar en Local (no cobra seña)'
                                            }
                                        ]}
                                        onChange={setImporteDebe}
                                        type="text"
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} >
                                    <Input
                                        label="Valor"
                                        value={importe_valor}
                                        onChange={setImporteValor}
                                        type="tel"
                                        helperText="Valor. Ej: 500 (si quiere cobrar $500 fijos) ó 0.3 (si quiere cobrar 30% del turno) ó  1 (si quiere cobrar el total)"
                                        restricciones={['soloNumerosDecimales']}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} >
                                    <hr />
                                </Grid>
                            </Grid>



                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose}>Cancelar</Button>
                            <Button type="submit">Guardar</Button>
                        </DialogActions>
                    </form>
                </Dialog>
            </>
        )

}